import {
  GET_REVENUE_CENTERS_REQUESTED,
  GET_REVENUE_CENTERS_SUCCEEDED,
  GET_REVENUE_CENTERS_FAILED,
  CREATE_REVENUE_CENTERS_REQUESTED,
  CREATE_REVENUE_CENTERS_SUCCEEDED,
  CREATE_REVENUE_CENTERS_FAILED,
  UPDATE_REVENUE_CENTERS_REQUESTED,
  UPDATE_REVENUE_CENTERS_SUCCEEDED,
  UPDATE_REVENUE_CENTERS_FAILED,
  GET_AVAILABILITY_REQUESTED,
  GET_AVAILABILITY_FAILED,
  GET_AVAILABILITY_SUCCEEDED,
  GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_SUCCEEDED,
  GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_REQUESTED,
  GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_FAILED,
  SET_REVENUE_CENTER_OPTIMISTIC_LIST_IMAGE,
} from './constants'
import api, { fetchAvailability } from '../../utils/api'
import { omit } from 'lodash'

export const setRevenueCenterOptimisticListImage = (payload) => ({
  type: SET_REVENUE_CENTER_OPTIMISTIC_LIST_IMAGE,
  payload,
})

export const getRevenueCentersRequested = () => ({
  type: GET_REVENUE_CENTERS_REQUESTED,
})

export const getRevenueCentersSucceeded = (payload) => ({
  type: GET_REVENUE_CENTERS_SUCCEEDED,
  payload,
})

export const getRevenueCentersFailed = () => ({
  type: GET_REVENUE_CENTERS_FAILED,
})

export const createRevenueCentersRequested = () => ({
  type: CREATE_REVENUE_CENTERS_REQUESTED,
})

export const createRevenueCentersSucceeded = (payload) => ({
  type: CREATE_REVENUE_CENTERS_SUCCEEDED,
  payload,
})

export const createRevenueCentersFailed = () => ({
  type: CREATE_REVENUE_CENTERS_FAILED,
})

export const updateRevenueCentersRequested = () => ({
  type: UPDATE_REVENUE_CENTERS_REQUESTED,
})

export const updateRevenueCentersSucceeded = (payload) => ({
  type: UPDATE_REVENUE_CENTERS_SUCCEEDED,
  payload,
})

export const updateRevenueCentersFailed = () => ({
  type: UPDATE_REVENUE_CENTERS_FAILED,
})

export const loadRevenueCenters =
  (venueUuid, includeSettings) => (dispatch) => {
    dispatch(getRevenueCentersRequested())
    return api
      .fetchRevenueCenters(venueUuid, includeSettings)
      .then((response) =>
        dispatch(getRevenueCentersSucceeded(response?.data?.stands))
      )
      .catch(() => dispatch(getRevenueCentersFailed()))
  }

export const createRevenueCenter = (data) => (dispatch) => {
  dispatch(createRevenueCentersRequested())
  return api
    .createRevenueCenters(data)
    .then((res) =>
      dispatch(createRevenueCentersSucceeded(res.data.stands))
    )
    .catch((err) => dispatch(createRevenueCentersFailed(err)))
}

export const updateRevenueCenter = (data) => (dispatch) => {
  dispatch(updateRevenueCentersRequested())

  // Menu Manager should not send the merchant_token in any payload
  const updatedRevenueCenterWithoutMerchantToken = omit(
    data,
    'merchantToken'
  )

  return api
    .updateRevenueCenters(updatedRevenueCenterWithoutMerchantToken)
    .then((res) =>
      dispatch(updateRevenueCentersSucceeded(res?.data?.stands))
    )
    .catch((err) => dispatch(updateRevenueCentersFailed(err)))
}

// paginated and filtered Revenue Centers

export const getFilteredAndPaginatedRevenueCentersRequested = () => ({
  type: GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_REQUESTED,
})

export const getFilteredAndPaginatedRevenueCentersSucceeded = (
  payload
) => ({
  type: GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_SUCCEEDED,
  payload,
})

export const getFilteredAndPaginatedRevenueCentersFailed = () => ({
  type: GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_FAILED,
})

export const loadPaginatedAndFilteredRevenueCenters =
  (params) => (dispatch) => {
    dispatch(getFilteredAndPaginatedRevenueCentersRequested())
    return api
      .fetchFilteredAndPaginatedRevenueCenters(params)
      .then((res) =>
        dispatch(getFilteredAndPaginatedRevenueCentersSucceeded(res))
      )
      .catch(() =>
        dispatch(getFilteredAndPaginatedRevenueCentersFailed())
      )
  }

export const createSettings = (data) => () => {
  return api.createSettings(data).then(() => {})
}

// Availability //

export const getAvailabilityRequested = () => ({
  type: GET_AVAILABILITY_REQUESTED,
})

export const getAvailabilitySucceeded = (payload) => ({
  type: GET_AVAILABILITY_SUCCEEDED,
  payload,
})
export const getAvailabilityFailed = (payload) => ({
  type: GET_AVAILABILITY_FAILED,
  payload,
})

export const loadAvailaibility = (venuUuid) => (dispatch) => {
  dispatch(getAvailabilityRequested())
  fetchAvailability(venuUuid)
    .then((res) =>
      dispatch(getAvailabilitySucceeded(res?.data?.revenueCenters))
    )
    .catch((err) => dispatch(getAvailabilityFailed(err)))
}
